Pixlee.module('SingleEmbedsApp.Embed', function(Embed, App, Backbone, Marionette, $) {

	Embed.Layout = App.Views.Layout.extend({
        template: require('./template/_single_embed_layout.jst.ejs'),
        id: 'single_embed_container',
        regions: {
            embed_region: '#embed_region'
        }
    });


	Embed.Item = App.Views.ItemView.extend({
		template: require('./template/_single_embed.jst.ejs'),
        initialize: function() {
            this.model.on('sync', this.modelRendered, this);
        },
        modelRendered: function() {
            this.render();
        },
        onRender: function() {
            if (this.$el.find('img').attr('src').length > 0) {
                this.resizeImageWithAspectRatio(this.$el.find('img'));
            }
        },
        resizeImageWithAspectRatio: function(img) {
            var maxWidth = this.maxWidth; // Max width for the image
            var maxHeight = this.maxHeight;    // Max height for the image
            var ratio = 0;  // Used for aspect ratio
            var width = img.width();    // Current image width
            var height = img.height();  // Current image height

            // Check if the current width is larger than the max
            if (width > maxWidth) {
                ratio = maxWidth / width;   // get ratio for scaling image
                img.css('width', maxWidth); // Set new width
                img.css('height', height * ratio);  // Scale height based on ratio
                height = height * ratio;    // Reset height to match scaled image
                width = width * ratio;    // Reset width to match scaled image
            }

            // Check if current height is larger than max
            if (height > maxHeight) {
                ratio = maxHeight / height; // get ratio for scaling image
                img.css('height', maxHeight);   // Set new height
                img.css('width', width * ratio);    // Scale width based on ratio
                width = width * ratio;    // Reset width to match scaled image
             }
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                getImage: function() {
                    return _this.model.attributes.source_url;
                }
            }, App.request('concern', 'PhotoHelpers'));
        }
	});
	Embed.Item.include(['socialShareHelpers']);

});
